export default __webpack_public_path__ + "static/media/leftArrow.77dc9124.svg";